const Style = {

  input: 'relative mb-4 last:mb-0',
  textbox: `relative block w-full p-3 rounded-control bg-white border border-solid border-sg-line
    focus:border-sg-blue focus:shadow-focus focus:outline-none appearance-none disabled:opacity-50`,

  cardbox: '!p-4',

  success: 'border border-solid border-sg-green',
  successIcon: 'absolute top-[2.8em] right-3',
  error: 'relative text-sg-red mb-0 border border-solid border-sg-red bg-sg-red-bg placeholder:text-sg-red',
  warning: 'bg-sg-orange-bg border border-solid border-sg-orange',

}

export default Style;